var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainContainer',{attrs:{"hideSidebar":true}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"4"}},[_c('Login')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }